export default __webpack_public_path__ + "static/media/search.d6cac7ae.svg";